import React from 'react'
import Profile from '../../Components/client/Profile'

function Profilee() {
  return (
    <div>
      <Profile/>
    </div>
  )
}

export default Profilee
